import {
  getStudentReportsByCenterId,
  getStudentReportsByPeriodId,
  getStudentReportsByCountries,
  //Lecturer
  getLecturerReports,
  getCertificatesReports,
  getCountryStudentReport,
} from "@/services/reports.service";
// initial state
const state = () => ({});

// mutations
const mutations = {};

// actions
const actions = {
  async loadStudentReportsByCenterId(vuexContext, co) {
    return await getStudentReportsByCenterId(co).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async loadStudentReportsByPeriodId(vuexContext, co) {
    return await getStudentReportsByPeriodId(co).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async loadStudentReportsByCountries(vuexContext, co) {
    return await getStudentReportsByCountries(co).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async loadLecturerReports(vuexContext, co) {
    return await getLecturerReports(co).then((response) => {
      let data = response.data.data;

      data.map((s, index) => {
        s.index = index + 1;
      });
      return data;
    });
  },

  async loadCertificatesReports(vuexContext, co) {
    return await getCertificatesReports(co).then((response) => {
      let data = response.data.data;

      data.map((s, index) => {
        s.index = index + 1;
      });
      return data;
    });
  },
  async loadCountryStudentReport(vuexContext, co) {
    return await getCountryStudentReport(co).then((response) => {
      //console.log("state",response);
      let data = response.data.data;
      data.map((s, index) => {
        s.index = index + 1;
      });
      return data;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
